import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from '@core/authentication/auth.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';
import { NavigationCardComponent } from './components/navigation-card.component';
import { SideBarService } from '@shared/services/sidebar-state.service';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatButtonModule,
    ButtonModule,
    NavigationCardComponent,
    TranslocoModule,
    SidebarModule,
  ],
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  showActors = false;
  #authService = inject(AuthService);
  #sidebarService = inject(SideBarService);

  isLoggedIn$ = this.#authService.isLoggedIn();

  openSidebar() {
    this.#sidebarService.openSideBar();
  }
}
